import { Routes } from '@angular/router';
import { UserCancel } from './features/activation-form/user-cancel/user-cancel';
import { SimActivation } from './features/activation-form/sim-activation/sim-activation';
import { Onboarding } from './features/activation-form/onboarding/onboarding';
import { ActivationForm } from './features/activation-form/activation-form';
import { UserRetry } from './features/activation-form/user-retry/user-retry';
import { InternalError } from './features/activation-form/internal-error/internal-error';
import { UserExceedLimits } from './features/activation-form/user-exceed-limits/user-exceed-limits';
import { ActivationSuccess } from './features/activation-form/activation-success/activation-success';
import { UserNotFound } from './features/activation-form/user-not-found/user-not-found';
import { ManualActivation } from './features/activation-form/manual-activation/manual-activation';
import { simGuard } from './core/guards/sim-guard';
import { TecnicalFailure } from './features/activation-form/tecnical-failure/tecnical-failure';
import { SimActivated } from './features/activation-form/sim-activated/sim-activated';

export const routes: Routes = [
  { path: '', component: Onboarding },
  { path: 'activate-form', component: ActivationForm, canActivate: [simGuard] },
  { path: 'user-cancel', component: UserCancel },
  { path: 'activate-sim', component: SimActivation },
  { path: 'user-retry/:attemps', component: UserRetry },
  { path: 'internal-error', component: InternalError },
  { path: 'user-exceed-limits', component: UserExceedLimits },
  { path: 'technical-failure', component: TecnicalFailure },
  { path: 'sim-activated', component: SimActivated },
  {path: 'activation-success', component: ActivationSuccess, canActivate: [simGuard]},
  {path: 'manual-activation', component: ManualActivation},
  {path: 'user-not-found', component: UserNotFound},
  {path: '**', redirectTo: ''}
];
